import settings from '@/data/constants';
import { QueryKey } from '@/data/query';
import { toast } from '@montugroup/design-system';
import type { apiV1Contract } from '@montugroup/pms-api-contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

type SaveConsultationData = Zod.infer<typeof apiV1Contract.consultation.updateConsultation.body>;
export type SaveConsultationParams = SaveConsultationData['data'];

export const useSaveConsultationData = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: async (payload: SaveConsultationParams) => {
      const response = await axios.post<SaveConsultationData, AxiosResponse<number>>(
        `${settings.url}/consultation/${payload.id}`,
        { data: payload },
      );
      return response.data;
    },
    mutationKey: [QueryKey.SaveConsultationData],
    onSuccess: () => {
      toast.success('Consultation Saved.');
      queryClient.invalidateQueries({ queryKey: [QueryKey.GetPatientConsultations] });
    },
    onError: () => {
      toast.error({
        title: 'Failed to Save Consultation',
        message: 'Please try again later.',
      });
    },
  });

  return {
    saveConsultationData: mutateAsync,
    ...rest,
  };
};
